import { render } from "./freezedModal.vue?vue&type=template&id=d7a3dad0&scoped=true&ts=true"
import script from "./freezedModal.vue?vue&type=script&lang=ts"
export * from "./freezedModal.vue?vue&type=script&lang=ts"

import "./freezedModal.vue?vue&type=style&index=0&id=d7a3dad0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7a3dad0"]])

export default __exports__